module.exports = (() => {

    const confidenceOf = (segment) => {
        return segment.entities[0].extractionConfidence;
    };

    const withMinConfidence = (segments, threshold) => {
        if (!segments) {
            return null;
        }

        return segments.filter(function(segment) {
            return confidenceOf(segment) >= threshold;
        });
    }

    const minConfidence = (segments) => {
        if (!segments) return 0.0;
        return Math.min.apply(null, segments.map(confidenceOf));
    }

    const uniqueBy = (segments, fn) => {
        var results = [];

        return segments.filter(function(segment) {
            var fnResult = fn(segment);

            if(results.indexOf(fnResult) === -1) {
                results.push(fnResult);
                return true;
            }

            return false;
        });
    }

    const groupByType = (segments) => {
        return segments.reduce(function(acc, segment) {
            var entityType = segment.entities[0].type;
            acc[entityType] = acc[entityType] || [];

            acc[entityType].push({
                'confidence': confidenceOf(segment),
                'text': segment.anchor.text,
                'raw': segment
            });

            return acc
        }, {});
    }

    const convertEntitiesToSegments = (entities) => {
        var segments = [];
        for (var i in entities) {
            var entity = entities[i];
            if ('mentions' in entity) {
                for (var j in entity['mentions']) {
                    var mention = entity['mentions'][j]
                    var segment = {
                        'anchor': {
                            'start': mention['position'][0],
                            'stop': mention['position'][1],
                            'text': mention['extractedText'] || ''
                        },
                        'entities': [
                            {
                                'attributes': entity['attributes'] || {},
                                'extractionConfidence': mention['extractionConfidence'] || 0.0,
                                'normalizedText': entity['label'] || '',
                                'type': entity['type'],
                                mention  // Used to show mention JSON in grouped sidebar
                            }
                        ]
                    }
                    if ('disambiguated' in entity) {
                        var disambiguatedResults = [
                            {
                                'attributes': entity['disambiguated'],
                                'id': entity['disambiguated']['id'] || null,
                                'permIds': entity['disambiguated']['permIds'] || null,
                                'spgId': (entity['disambiguated']['spgId'] || entity['disambiguated']['sandpId']) || null,
                                'label': entity['label'] || '',
                                'score': mention['disambiguationConfidence'] || 0.0
                            }
                        ]
                        segment['entities'][0]['disambiguationResults'] = disambiguatedResults;
                    }

                    // Push the overall entity sentiment to each segment so it's available in grouped sidebar
                    if ('sentiment' in entity) {
                        segment['entities'][0]['overallSentiment'] = entity.sentiment;
                    }

                    // Push salienceScore 
                    if ('salienceScore' in entity) {
                        segment['entities'][0]['salienceScore'] = entity.salienceScore;
                    }

                    // Push entitySummary 
                    if ('entitySummary' in entity) {
                        segment['entities'][0]['entitySummary'] = entity.entitySummary;
                    }

                    segments.push(segment);
                }
            }
        }

        // Sort the segments so they are in anchor order
        segments.sort(function(a, b) {
            return parseFloat(a.anchor.start) - parseFloat(b.anchor.start);
        });

        return segments;
    }

    return {
    	withMinConfidence,
		minConfidence,
		uniqueBy,
        groupByType,
        convertEntitiesToSegments
	}
})();


